import React from 'react';
import Styled from 'styled';
import ImageView from 'lib/images/image-view';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import IconUser from 'four-nets/icons/svg/icon_user.svg';
import { displayedName } from 'four-nets/user/utils';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';
import { Link } from 'react-router-dom';

import { LatestAlbumFragment, LatestAlbumImagesFragment, LatestAlbumPhotoFileFragment } from './latest-album.graphql';
import defaultStyles from './latest-album.scss';

export interface Props extends LatestAlbumFragment {
    styles: typeof defaultStyles;
}

export interface State {
    open: boolean;
}

export function getFirstImage(images: LatestAlbumImagesFragment | null): LatestAlbumPhotoFileFragment | undefined {
    if (images && images.edges) {
        for (const edge of images.edges) {
            if (edge && edge.node && edge.node.photoFile) {
                return edge.node.photoFile;
            }
        }
    }
}

export function getAlt(images: LatestAlbumImagesFragment | null): string | undefined {
    if (images && images.edges) {
        for (const edge of images.edges) {
            if (edge && edge.node && edge.node.alt) {
                return edge.node.alt;
            }
        }
    }
}

class LatestAlbum extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { open: false };
    }

    close = () => {
        this.setState({ open: false });
    };

    open = () => {
        this.setState({ open: true });
    };

    render() {
        const { styles, slug, user } = this.props;
        const isVendor = user && user.profile && user.profile.isVendor;
        const firstImage = getFirstImage(this.props.images);
        const firstImageAlt = getAlt(this.props.images);

        return (
            <div className={styles.album}>
                <a
                    href={
                        isVendor
                            ? `/catalog/vendor/${user.username}/blog-album/${slug}/`
                            : `/blog/${user.username}/album/${slug}/`
                    }
                    className={styles.link}
                >
                    <div className={styles.image}>
                        {firstImage ? (
                            <ImageView
                                aspectFill={true}
                                srcSet={firstImage.srcset || ''}
                                src={firstImage.src}
                                sizes={{ xs: '50vw', md: 150 }}
                                alt={firstImageAlt}
                                linkify={false}
                            />
                        ) : null}
                    </div>
                    <p className={styles.title}>
                        <TextShortener text={this.props.title} textLength={35} />
                    </p>
                </a>
                <div className={styles.stats}>
                    <Link className={styles.link} to={`/blog/${user.username}/`}>
                        <SVGIcon style={{ image: styles.icon }} src={IconUser} />
                        <span className={styles.stat}>{displayedName(user)}</span>
                    </Link>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(LatestAlbum);
